
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(142),
  account_hash: String.withConstraint(x => x.length <= 32),
  client_language_code: String,
  client_version: String.withConstraint(x => x.length <= 90),
  device_id: Number.withConstraint(x => x >= 0 && x <= 50),
  device_language_code: String,
  gamestate_count_session: Number.withConstraint(x => x >= 1),
  gamestate_name: String.withConstraint(x => x.length <= 60),
  platform_id: Number.withConstraint(x => x >= 0 && x <= 10),
  playerId: Number.withConstraint(x => x >= -1),
  session_count: Number.withConstraint(x => x >= 0),
  session_length_ms: Number,
  session_type_name: String.withConstraint(x => x.length <= 30),
  is_html5: Number.withConstraint(x => x >= 0 && x <= 1),
}).And(Partial({
  connection_type_name: String.withConstraint(x => x.length <= 20),
  client_timestamp: Number.withConstraint(x => x >= 0),
  event_mapping_version: Number.withConstraint(x => x >= 1 && x <= 10),
  install_source_name: String.withConstraint(x => x.length <= 30),
  ip_long: Number,
  media_partner_id: Number.withConstraint(x => x >= 0),
  referrer_name: String.withConstraint(x => x.length <= 100),
  website_id: Number.withConstraint(x => x >= 0),
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(142),
  account_hash: String.withConstraint(x => x.length <= 32),
  client_language_code: String,
  client_version: String.withConstraint(x => x.length <= 90),
  device_id: Number.withConstraint(x => x >= 0 && x <= 50),
  device_language_code: String,
  gamestate_count_session: Number.withConstraint(x => x >= 1),
  gamestate_name: String.withConstraint(x => x.length <= 60),
  platform_id: Number.withConstraint(x => x >= 0 && x <= 10),
  playerId: Number.withConstraint(x => x >= -1),
  session_count: Number.withConstraint(x => x >= 0),
  session_length_ms: Number,
  session_type_name: String.withConstraint(x => x.length <= 30),
  is_html5: Number.withConstraint(x => x >= 0 && x <= 1),
}).And(Partial({
  connection_type_name: String.withConstraint(x => x.length <= 20),
  client_timestamp: Number.withConstraint(x => x >= 0),
  event_mapping_version: Number.withConstraint(x => x >= 1 && x <= 10),
  install_source_name: String.withConstraint(x => x.length <= 30),
  ip_long: Number,
  media_partner_id: Number.withConstraint(x => x >= 0),
  referrer_name: String.withConstraint(x => x.length <= 100),
  website_id: Number.withConstraint(x => x >= 0),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
  instanceId: Number.withConstraint(x => x >= -10 && x <= 1000),
  networkId: Number.withConstraint(x => x >= 0 && x <= 1000),
  zoneId: Number.withConstraint(x => x >= -1 && x <= 1000),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 142;
  